import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "../../Common";
import {
  getTopicUsers,
  setLoadingTopicUsers,
  setTopicUsers,
  setTopicUsersError
} from "../../Startup/Actions/StartupActions";
import { UserTopicAssignment } from "../Models/UserTopicAssignment";

const useTopicUsers = (topicCode: string) => {
  const dispatch = useDispatch();

  return useSelector((state: IAppState) => ({
    userLoadState: state.app.topicUsersLoadingState[topicCode],
    userLoadError: state.app.topicUsersError[topicCode],
    users: state.app.topicUsers[topicCode],
    setLoadingTopicUsers: () => dispatch(setLoadingTopicUsers(topicCode)),
    setTopicUsers: (managers: UserTopicAssignment[]) =>
      dispatch(setTopicUsers(topicCode, managers)),
    getTopicUsers: () => dispatch(getTopicUsers(topicCode))
  }));
};

export default useTopicUsers;
